
// API endpoint
export const BASE_URL = "https://collection.brandsmeetcreators.online/v1/api/social-media-tools/tiktok/collection-videos";

// API request timeout in milliseconds
export const API_TIMEOUT = 15000;

// Maximum number of retries for failed requests
export const MAX_RETRIES = 2;

// Default count of videos to fetch per page
export const DEFAULT_COUNT = 30;
